module.exports = __webpack_public_path__ + "static/media/under-dog.8678d52f.png";